import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import { IDropdownSettings } from "ng-multiselect-dropdown";

@Component({
  selector: "app-multi-select-dropdown",
  templateUrl: "./multi-select-dropdown.component.html",
  styleUrls: ["./multi-select-dropdown.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class MultiSelectDropdownComponent implements OnInit {
  @Input() list;
  @Input() conf;
  @Input() selectedItems = [];

  @Output() sendValue = new EventEmitter<any>();

  dropdownList = [];
  dropdownSettings: IDropdownSettings;
  constructor() {}

  ngOnInit(): void {
    console.log(this.conf);
    console.log(this.list);
    this.dropdownList = this.list;
    this.dropdownSettings = {
      singleSelection: false,
      idField: this.conf.id,
      textField: this.conf.text,
      selectAllText: "Seleccionar todos",
      unSelectAllText: "Deseleccionar todos",
      searchPlaceholderText: 'Buscar',
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };
  }

  onItemSelect($event) {
    this.sendValue.emit({ list: this.selectedItems, id: this.conf.id });
  }
  onSelectAll($event) {
    this.sendValue.emit({ list: $event, id: this.conf.id });
  }
  onItemDeSelect($event) {
    this.sendValue.emit({ list: this.selectedItems, id: this.conf.id });
  }
  onDeSelectAll($event) {
    this.sendValue.emit({ list: $event, id: this.conf.id });
  }
}
